/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER is a full anagram of GARDEN — both use exactly the letters G, A, R, D, E, N. GANDER means an adult male goose, and it shares those same six letters with DANGER and RANGED, making all three words interchangeable rearrangements of one another.`)
};

const es_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER es un anagrama completo de GARDEN —ambas usan exactamente las letras G, A, R, D, E, N. GANDER significa ganso macho adulto, y comparte esas mismas seis letras con DANGER y RANGED, lo que hace que las tres palabras sean reordenaciones intercambiables entre sí.`)
};

const de_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER ist ein vollständiges Anagramm von GARDEN — beide nutzen genau die Buchstaben G, A, R, D, E, N. GANDER bedeutet ein ausgewachsenes männliches Gänse-Tier (Ganter), und es teilt dieselben sechs Buchstaben mit DANGER und RANGED, wodurch alle drei Wörter austauschbare Umstellungen voneinander sind.`)
};

const nl_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER is een volledig anagram van GARDEN — beide gebruiken precies de letters G, A, R, D, E, N. GANDER betekent een mannetjesgans, en het deelt diezelfde zes letters met DANGER en RANGED, waardoor alle drie de woorden onderlinge herschikkingen van elkaar zijn.`)
};

const fr_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER est une anagramme complète de GARDEN — les deux utilisent exactement les lettres G, A, R, D, E, N. GANDER désigne un jars (oie mâle adulte), et il partage ces mêmes six lettres avec DANGER et RANGED, ce qui fait de ces trois mots des réarrangements interchangeables les uns des autres.`)
};

const it_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER è un anagramma completo di GARDEN — entrambe usano esattamente le lettere G, A, R, D, E, N. GANDER significa oca maschio adulta, e condivide queste stesse sei lettere con DANGER e RANGED, rendendo tutte e tre le parole riordini intercambiabili l'una dell'altra.`)
};

const pt_br2_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER é um anagrama completo de GARDEN — ambas usam exatamente as letras G, A, R, D, E, N. GANDER significa um ganso macho adulto, e compartilha essas mesmas seis letras com DANGER e RANGED, o que torna as três palavras rearranjos intercambiáveis entre si.`)
};

const pt_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER é um anagrama completo de GARDEN — ambas usam exatamente as letras G, A, R, D, E, N. GANDER significa um ganso macho adulto, e partilha essas mesmas seis letras com DANGER e RANGED, o que faz das três palavras reorganizações intercambiáveis umas das outras.`)
};

const ja_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDERはGARDENの完全なアナグラムです — どちらもまったく同じ文字G, A, R, D, E, Nを使っています。GANDERは成体のオスのガチョウを意味し、DANGERやRANGEDと同じ6文字を共有しているため、この3つの単語は互いに並べ替え可能な関係にあります。`)
};

const zh_wu_c_garden_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER 是 GARDEN 的完整易位构词——两者使用的都恰好是 G、A、R、D、E、N 这几个字母。GANDER 指成年雄鹅，它与 DANGER 和 RANGED 共享同样的六个字母，这三个单词彼此互为可以互换的重新排列。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_garden_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_garden_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_garden_faq2_a", locale)
	if (locale === "en") return en_wu_c_garden_faq2_a(inputs)
	if (locale === "es") return es_wu_c_garden_faq2_a(inputs)
	if (locale === "de") return de_wu_c_garden_faq2_a(inputs)
	if (locale === "nl") return nl_wu_c_garden_faq2_a(inputs)
	if (locale === "fr") return fr_wu_c_garden_faq2_a(inputs)
	if (locale === "it") return it_wu_c_garden_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_garden_faq2_a(inputs)
	if (locale === "pt") return pt_wu_c_garden_faq2_a(inputs)
	if (locale === "ja") return ja_wu_c_garden_faq2_a(inputs)
	return zh_wu_c_garden_faq2_a(inputs)
};